
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.833 12.688a.45.45 0 01-.458-.438V1.75a.45.45 0 01.458-.438h4.584V3.5c0 .484.41.875.916.875h2.292v7.875a.45.45 0 01-.458.438H3.833zM3.833 0C2.823 0 2 .785 2 1.75v10.5c0 .965.822 1.75 1.833 1.75h7.334c1.01 0 1.833-.785 1.833-1.75V4.225c0-.465-.192-.91-.536-1.24L9.87.512A1.872 1.872 0 008.574 0h-4.74zm2.75 7a.855.855 0 00-.268-.619.94.94 0 00-.648-.256.94.94 0 00-.649.256A.855.855 0 004.75 7c0 .232.097.455.268.619a.94.94 0 00.649.256.94.94 0 00.648-.256A.855.855 0 006.583 7zm1.983 1.282a.467.467 0 00-.379-.188.467.467 0 00-.378.188L6.626 9.915l-.34-.522a.463.463 0 00-.39-.206.467.467 0 00-.39.206l-1.146 1.75a.419.419 0 00-.011.442.46.46 0 00.401.225h5.5c.172 0 .327-.09.407-.235a.416.416 0 00-.029-.452L8.566 8.28v.002z","fill":"#9DA7B2"}})])
          )
        }
      }
    